import React, { useState, useEffect, useRef } from 'react';

const initials = (name) => {
  if (!name) return '?';
  const p = name.trim().split(' ');
  return p.length >= 2 ? (p[0][0]+p[1][0]).toUpperCase() : name.slice(0,2).toUpperCase();
};

const MenuItem = ({ icon, label, sub, onClick, danger }) => (
  <button
    onClick={onClick}
    style={{
      display:'flex', alignItems:'center', gap:11, width:'100%', padding:'9px 12px',
      borderRadius:9, border:'none', background:'transparent', cursor:'pointer',
      textAlign:'left', transition:'background 0.12s', fontFamily:'inherit',
    }}
    onMouseEnter={e => e.currentTarget.style.background = danger ? '#fef2f2' : '#f5f5f3'}
    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
  >
    <span style={{ color: danger ? '#ef4444' : '#555', flexShrink:0 }}>{icon}</span>
    <div style={{ flex:1, minWidth:0 }}>
      <div style={{ fontSize:13, fontWeight:500, color: danger ? '#ef4444' : '#0a0a0a' }}>{label}</div>
      {sub && <div style={{ fontSize:11, color:'#aaa', marginTop:1 }}>{sub}</div>}
    </div>
  </button>
);

export default function ProfileMenu({ user, onNav, onLogout }) {
  const [open, setOpen]   = useState(false);
  const [avatar, setAvatar] = useState(() => localStorage.getItem('talku_avatar') || '');
  const ref = useRef(null);

  useEffect(() => {
    const sync = () => setAvatar(localStorage.getItem('talku_avatar') || '');
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const go = (screen) => { setOpen(false); if (onNav) onNav(screen); };
  const logout = () => { setOpen(false); if (onLogout) onLogout(); };

  const AvatarImg = ({ size }) => (
    <div style={{
      width:size, height:size, borderRadius:'50%', background:'#0a0a0a',
      overflow:'hidden', flexShrink:0, display:'flex', alignItems:'center',
      justifyContent:'center',
    }}>
      {avatar
        ? <img src={avatar} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
        : <svg width={size} height={size} viewBox="0 0 34 34" fill="none">
            <rect width="34" height="34" fill="#0a0a0a"/>
            <circle cx="17" cy="13" r="6" fill="#6ee7b7" opacity="0.9"/>
            <ellipse cx="17" cy="27" rx="10" ry="7" fill="#6ee7b7" opacity="0.55"/>
          </svg>
      }
    </div>
  );

  return (
    <div ref={ref} style={{ position:'relative', flexShrink:0 }}>
      {/* Pill */}
      <div
        onClick={() => setOpen(o => !o)}
        style={{
          display:'flex', alignItems:'center', gap:9,
          background:'rgba(255,255,255,0.78)',
          border:'1px solid rgba(255,255,255,0.65)',
          backdropFilter:'blur(10px)', WebkitBackdropFilter:'blur(10px)',
          borderRadius:999, padding:'5px 14px 5px 5px', cursor:'pointer',
          userSelect:'none',
        }}
      >
        <AvatarImg size={34}/>
        <div>
          <div style={{ fontSize:13, fontWeight:700, color:'#0a0a0a', lineHeight:1.3 }}>
            {user?.name?.split(' ')[0] || 'Usuario'}
          </div>
          <div style={{ fontSize:11, color:'#999' }}>{user?.role || 'Agente'}</div>
        </div>
        <svg
          width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="#bbb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ marginLeft:4, transition:'transform 0.15s', transform: open ? 'rotate(180deg)' : 'none' }}
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>

      {/* Dropdown */}
      {open && (
        <div style={{
          position:'absolute', top:'calc(100% + 8px)', right:0,
          background:'#fff', borderRadius:14, minWidth:230,
          boxShadow:'0 8px 32px rgba(0,0,0,0.13), 0 2px 8px rgba(0,0,0,0.06)',
          border:'1px solid #eeeeed', padding:6, zIndex:9999,
        }}>
          {/* User header */}
          <div style={{ padding:'10px 12px 12px', borderBottom:'1px solid #f0f0ee', marginBottom:4 }}>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <AvatarImg size={40}/>
              <div style={{ minWidth:0 }}>
                <div style={{ fontSize:13, fontWeight:700, color:'#0a0a0a', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {user?.name || '—'}
                </div>
                <div style={{ fontSize:11, color:'#aaa', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {user?.email || ''}
                </div>
                <div style={{ marginTop:4, display:'inline-block', padding:'2px 8px', borderRadius:20, fontSize:10, fontWeight:700,
                  background: user?.role === 'Administrador' ? '#ede9fe' : '#dcfce7',
                  color: user?.role === 'Administrador' ? '#6d28d9' : '#15803d',
                }}>
                  {user?.role || '—'}
                </div>
              </div>
            </div>
          </div>

          <MenuItem
            onClick={() => go('Configuraciones')}
            label="Mi perfil"
            sub="Foto, nombre y contraseña"
            icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>}
          />
          <MenuItem
            onClick={() => go('Configuraciones')}
            label="Configuraciones"
            sub="Usuarios, canales y tiendas"
            icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>}
          />

          <div style={{ height:1, background:'#f0f0ee', margin:'4px 0' }}/>

          <MenuItem
            onClick={logout}
            label="Cerrar sesión"
            danger
            icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>}
          />
        </div>
      )}
    </div>
  );
}
